import { createContext } from 'react';
import { ResolvedTheme, ThemeMode, THEME_MODE } from './constants';

export interface IThemeContext {
  mode: ThemeMode;
  resolvedTheme: ResolvedTheme;
  setMode: (mode: ThemeMode) => void;
}

// A usable default, so a component rendered outside the provider (Storybook, an isolated test)
// shows the light theme instead of crashing.
export const ThemeContext = createContext<IThemeContext>({
  mode: THEME_MODE.SYSTEM,
  resolvedTheme: THEME_MODE.LIGHT,
  setMode: () => undefined,
});
